import Schema from "../model/schema";
import SchemaArray from "../model/schemaArray";

export default function isSchemaArray(object: Schema): object is SchemaArray {
    return "items" in object;
}